<template>
  <div class="container">
    <section class="section">
      <h1 class="title">Como van las Encuestas</h1>
      <h2 class="subtitle">Aqui podra consultar el status de las encuestas</h2>
      <hr />
      <button class="button is-light">Cerrar encuestas</button>
      <button class="button is-link">Reabrir Encuestas</button>

      <hr />
      <div class="columns">
        <div class="column">
          <div class="box">
            <h1 class="subtitle is-5">Participación</h1>
            <y-graph :datagraph="datagraph" :cambio="0"></y-graph>
          </div>
        </div>
        <div class="column">
          <div class="box">
            <table class="table">
              <thead>
                <tr>
                  <th>Encuestas</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total</td>
                  <td>100</td>
                </tr>
                <tr>
                  <td>Terminadas</td>
                  <td>25</td>
                </tr>
                <tr>
                  <td>Participación</td>
                  <td>25%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import yGraph from "@/components/dashboard/Graph.vue";
export default {
  data() {
    return {
      datagraph: {},
    };
  },
  components: {
    yGraph,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/clima/menuclima/Statussurveys.vue